import React from 'react';
import { RotateSpinner } from "react-spinners-kit";

const Loading = () => {
  return (
    <div className="loading-spinner">
      <RotateSpinner color="#2EB086" />
    </div>
  );
}
 
export default Loading;